export const DRILL_SESSION_QUOTA_EXCEEDED = "DRILL_SESSION_QUOTA_EXCEEDED";

export type DrillSessionQuota = {
    drillId: string;
    executionsUsed: number;
    executionsLimit: number;
    blocked: boolean;
};

export function resolveDrillQuota(
    planDuration: number | undefined,
    drills: DrillSessionQuota[] | undefined,
    drillId: string
): DrillSessionQuota {
    const item = drills?.find((drill) => drill.drillId === drillId);
    const executionsLimit = item?.executionsLimit ?? planDuration ?? 0;
    const executionsUsed = item?.executionsUsed ?? 0;
    const blocked = item?.blocked ?? (executionsLimit > 0 && executionsUsed >= executionsLimit);
    return {
        drillId,
        executionsUsed,
        executionsLimit,
        blocked,
    };
}
